<template>
  <div class="layout-box">
    <LayoutHeader :kls="true"></LayoutHeader>
    <div class="secondary-content">
      <div class="experts-title">
        <h2></h2>
        <ul class="cut-title">
          <li :class='num==0?"on":""' @click="cutlist(0)">托盘购买</li>
          <li :class='num==1?"on":""' @click="cutlist(1)">托盘租赁</li>
        </ul>
      </div>
      <ul class="goods-list clear" :style='num==0?"display: block;":"display: none;"'>
        <li v-for="(item,index in datas2" :key="index">
          <router-link :to="'/malldetail?id='+item.itemId">
          <h3 :title="item.itemName">{{ item.itemName }}</h3>
          <font>{{ item.itemDesc }}</font>
          <span>￥<i>{{ item.itemPrice }}</i>/个</span>
          <p><em>放心购</em><em>新材料</em></p>
          <b>购买>></b>
          <img :src="item.url"/>
          </router-link>
        </li>
      </ul>
      <ul class="goods-list clear" :style='num==1?"display: block;":"display: none;"'>
        <li v-for="(item,index) in datas" :key="index">
          <router-link :to="'/malldetail?id='+item.itemId">
            <h3 :title="item.itemName">{{ item.itemName }}</h3>
            <font>{{ item.itemDesc }}</font>
            <span>￥<i>{{ item.itemPrice }}</i>/天</span>
            <p><em>放心购</em><em>新材料</em></p>
            <b>购买>></b>
            <img :src="item.url"/>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from './pallet-header'

export default {
  name: 'PalletIndex',
  components:{
    LayoutHeader
  },
  data () {
    return {
      datas:[],
      datas2:[],
      num:0
    }
  },
  mounted () {
    this.getgoodslist(2)
    this.getgoodslist(1)
  },
  methods:{
    getgoodslist (typenum){
      let $this=this
      const url = '/mall/traySaleItem/mobile/findSaleItemList.html'
      $this.$api.get(url, {userId:300004432,token:'0e24d657c8b144b3a22521590906833f300004432',pageNo:1,itemType:typenum,pageSize:100,orderByStatus:1,orderByType:1}, (response) => {
        let datas=response.data.data.list||''
        if(datas){
          typenum==2?$this.datas2=datas:$this.datas=datas;
        }
      })
    },
    cutlist(n){
      this.num=n;
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  z-index: 1;
  top:0;
  left: 0;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}

.secondary-content{
  width: 1200px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}


.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(215,243,254,.4),rgba(16,57,180,.18));
  display: flex;
  justify-content: space-between;
}

.experts-title h2{
  font-family: "微软雅黑";
  line-height: 59px;
  color:#fff;
  padding-left: 20px;
}

.goods-list{
  width: 1200px;
  margin-bottom: 20px;
  background: #fff;
}

.goods-list li{
  width: 259px;
  height: 308px;
  padding: 20px;
  background: #fff;
  position: relative;
  border-bottom: 1px solid #08288F;
  border-right: 1px solid #08288F;
  float: left;
  overflow: hidden;
}

.goods-list li h3{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #434343;
  margin-bottom: 5px;
}

.goods-list li img{
  width: 100%;
  max-height: 191px;
  position: absolute;
  left: 0;
  bottom: 1px;
}

.goods-list li font{
  line-height: 120%;
  width: 258px;
  color: #999;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space:normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
}

.goods-list li span{
  color: #C60000;
  display: block;
  font-size: 16px;
  margin: 3px 0 4px 0;
}

.goods-list li i{
  font-size: 21px;
  font-style: normal;
  font-weight: bold;
}

.goods-list li b{
  color: #E26223;
  cursor: pointer;
  font-weight: normal;
}

.goods-list li a{
  text-decoration: none;
}

.goods-list li em{
  border: 1px solid #7FBFFF;
  display: inline-block;
  padding: 3px 10px;
  color: #0081FF;
  font-size: 12px;
  font-style: normal;
  margin-right: 8px;
}

.goods-list li em:nth-child(2){
  border: 1px solid #9BDAA4;
  color: #39B54A;
}

.cut-title{
  width: 320px;
  display: flex;
  justify-content: space-around;
  align-self: flex-end;
}

.cut-title li{
  height: 42px;
  color: #fff;
  font-size: 18px;
  line-height: 42px;
  padding: 0 35px;
  font-family: 微软雅黑;
  background-image: linear-gradient(rgba(33,84,235,1),rgba(45,91,237,.54));
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  cursor: pointer;
}

.cut-title li:hover{
  text-shadow: 0 4px 2px rgba(0, 0, 0, 0.7);
  background-image: linear-gradient(rgba(45,91,237,.54),rgba(33,84,235,1));
}

.cut-title li.on{
  background-image: linear-gradient(rgba(243,116,118,1),rgba(243,116,118,.54));
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/views/pallet/pallet-mall.vue